export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SelectedSinistersSummary.vue?vue&type=template&id=0f8ed9c0"


//////////////////
// WEBPACK FOOTER
// ./src/pages/extranet/SelectedSinistersSummary.vue?vue&type=template&id=0f8ed9c0
// module id = 2078
// module chunks = 31